import { archiveProject } from "../controller/archive-project"
import { unarchiveProject } from "../controller/unarchive-project"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"

export async function toggleProjectArchive({ project, dialog }) {
    const archived = !!project?.archived
    try {
        const confirmed = await dialog()
        if (!confirmed) return false
        const action = archived ? unarchiveProject : archiveProject
        const result = await action({ projectId: project?.id })
        if (!result?.success) {
            errorSnackbar(
                result?.error || (archived ? "Failed to restore work package" : "Failed to archive work package")
            )
            return false
        }
        successSnackbar(archived ? "Work package restored" : "Work package archived")
        return true
    } catch (e) {
        console.error(e)
        errorSnackbar(archived ? "Failed to restore work package" : "Failed to archive work package")
        return false
    }
}
